import { Injectable, inject } from "@angular/core";
import { filter, Observable, switchMap } from "rxjs";
import { BaseHttpService } from "../../services/common/base.http.service";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { IImprestVendor } from "../models/imprest-vendor.model";
import { administrationConst } from "../administration.const";
import { HttpHeaders } from "@angular/common/http";
import { IUpdateImprestVendor } from "../models/update-imprest-vendor.model";
import { SearchImprestChangesModel } from "../models/search-imprest-changes.model";
import { SearchParameters } from "../../shared/models/searchParameters.model";
import { PagedResult } from "../../shared/models/pagedResult.model";
import { ImprestVendorsChangesModel } from "../models/imprest-vendor-changes.model";

@Injectable({
    providedIn: 'root'
  })
  export class ImprestService {
    baseHttpService = inject(BaseHttpService);
    loggedInUserService = inject(LoggedInUserService);
    userEmail: string;

    getImprestVendors(): Observable<IImprestVendor[]> {
        return this.baseHttpService.get<IImprestVendor[]>(administrationConst.imprestVendors);
    }

    getAddressBookAlphaName(addressBookNumber: string): Observable<string> {
        return this.baseHttpService.get<string>(administrationConst.addressBookAlphaName + addressBookNumber);
    }

    updateImprestVendor(imprestVendor: IImprestVendor): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.loggedInUserService.currentUser$
          .pipe(
            filter(data => data !== null),
            switchMap(data => {
                const updateImprestVendor: IUpdateImprestVendor = {
                    currency: imprestVendor.currency,
                    vendor: imprestVendor.vendor,
                    payee: imprestVendor.payee,
                    updatedByName: data.userName,
                    updatedByEmail: data.userEmail
                };
                return this.baseHttpService.put(administrationConst.imprestVendors, updateImprestVendor, { headers: headers });
            })
        );
    }

    searchImprestVendorsChanges(searchParameters: SearchParameters<SearchImprestChangesModel>): Observable<PagedResult<ImprestVendorsChangesModel[]>> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.baseHttpService.post<PagedResult<ImprestVendorsChangesModel[]>>(administrationConst.imprestVendorsChanges, searchParameters, { headers: headers });
    }
}